import React from 'react';
import { Card, CardBody, Col } from 'reactstrap';
import Chart from 'react-google-charts';

const DSO = () => {
  const data = [
    ['Month', 'Days Outstanding'],
    ['January', 40],
    ['February', 42],
    ['March', 45],
    ['April', 43],
    ['May', 44],
  ];

  const options = {
    title: 'Days Sales Outstanding (DSO)',
    hAxis: { title: 'Month' },
    vAxis: { title: 'Days Outstanding' },
    legend: { position: 'top' },
    curveType: 'function',
    colors: ['#FF9800'],
  };

  return (
    <Col className="col-sm-12 col-xl-6 box-col-6">
      <Card>
        <CardBody>
          <Chart
            width={'100%'}
            height={'400px'}
            chartType="LineChart"
            loader={<div>Loading Chart...</div>}
            data={data}
            options={options}
          />
        </CardBody>
      </Card>
    </Col>
  );
};

export default DSO;